function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "roaming-hi-dark_svg__a",
  x1: 578.75,
  y1: -2858,
  x2: 611.98,
  y2: -2858,
  gradientTransform: "matrix(.71 .71 -1.26 1.27 -3919.75 3293.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Roaming_ic_hi 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.2 76.93a9 9 0 00-6.9-.38L16 79.22 29.32 95.6l20.89-7.47z",
  fill: "#e60000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.32 52.39l-35 12.51-29.84 10.64-35.27 12.6-20.89 7.46.35.43c10.08 12 25 16.54 39.79 11.34l88.93-32a27.48 27.48 0 0017.51-19.09 27.47 27.47 0 00-25.58-3.89z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M192 192H0V0h191.5l.5 192z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.4 73.06L69.46 105c-14.81 5.21-29.71.69-39.79-11.34L17.38 78.62l-1.43.6L29.68 96c10.08 12 25 16.54 39.79 11.34l88.93-32a27.48 27.48 0 0017.51-19.09l-.63-.44a27.44 27.44 0 01-16.88 17.25z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fill: "url(#roaming-hi-dark_svg__a)",
  d: "M104.69 94.78L91.75 81.91l33.18-11.86 12.82 12.75-33.06 11.98z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.87 82L56.38 46.12l9.86-3.46a10.45 10.45 0 018.14.51l50.87 27",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.06,
  d: "M122.98 69L91.87 80 57.84 45.61l-1.46.51L91.87 82l33.38-11.8-2.27-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.15 151.82l-140 .37a2 2 0 010-4l140-.37a2 2 0 110 4z",
  fill: "#4a4d4e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e60000",
  d: "M15.96 79.22l.33-.14-.33.14z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.06,
  d: "M17.38 78.62l-1.09.46 1.09-.46z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.88 95c-.41-.45-.81-.9-1.2-1.37l-12.3-15.01-1.1.46-.33.14L29.32 95.6z",
  fill: "#e60000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.88 95c-.41-.45-.81-.9-1.2-1.37l-12.3-15.01-1.1.46-.33.14L29.32 95.6z",
  opacity: 0.12
}));

var SvgRoamingHiDark = function SvgRoamingHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Apps_ic",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgRoamingHiDark;